import { useScreenSize } from '@banhala/ui-kit';

export const useGuardedScreenWidth = (_componentName: string) => {
  const { width } = useScreenSize();
  return width;
};
